export default __webpack_public_path__ + "static/media/circle-minus.4d520219.svg";